import React, { useState, useEffect, useCallback } from "react";
import "./Home.css";
import { 
  getToken, 
  getUser, 
  // salesClick, 
  getNeighborhoodCollapsed, 
  storeNeighborhoodCollapsed, 
  getUserInformation,
  setDefaultPageNumber, 
  setDefaultSortParameter, 
  setDefaultDaylightParameter, 
  setDefaultCameraDirections,
  removeDefaultEventParameters
} from "../utils/Common";
// import { PageHeader, ListGroup, ListGroupItem, Button, Glyphicon, Tooltip, OverlayTrigger } from "react-bootstrap";
// import { LinkContainer } from "react-router-bootstrap";
// import { View } from "react-native";
// import Select from "react-select";
import { 
  getCaps, 
  recordUserAction, 
  companyCamAccessToken,
  createCCIntegration,
  patchUserTZ,
} from "../utils/bedrockAPI";
import Collapsible from 'react-collapsible';
import SharingModal from "../components/SharingModal";
import Nudge from "../containers/Nudge.js";
import CapPanel from "../components/CapPanel";

export default function Dashboard2(props) {
  const [caps, setCaps] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [localToken, setLocalToken] = useState("");
  const [sharableCap, setsharableCap] = useState(null);
  const [showSharingWindow, setShowSharingWindow] = useState(false);
  // const [sharedEmail, setSharedEmail] = useState("");
  const [neighborhoodCollapsed, setNeighborhoodCollapsed] = useState({});
  const [neighborhoods, setNeighborhoods] = useState(null);
  const [buttonSize, setButtonSize] = useState("large");
  const [buildCaps, setBuildCaps] = useState(false);
  const [companyCamCode, setCompanyCamCode] = useState(null);
  const [CCAccessToken, setCCAccessToken] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if(isMounted) setLocalToken(getToken());
    if(window.innerWidth<767 && isMounted) {
      setButtonSize("small");
    }
    if(props.errorStatus!=='nudge-message' && isMounted) {
      props.setShowError(false);
    }
    if(isMounted) {
      recordUserAction(getUser().userId,"dashboard",null,{'userData':getUserInformation()});
      removeDefaultEventParameters();
    }

    let user = getUser();
    if(user && (!user.firstName || user.firstName==="")) {
      props.history.push('/account/info');
    }
    if(user && (user.role==='PAYMENTS')) {
      props.history.push('/reserve');
    }
    // props.setErrorMessage("We're currently experiencing an issue with our image API, you won't be able to pull live images.  We're working on a fix and will update you shortly.");
    // props.setErrorStatus("error-message");
    // props.setShowError(true);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let code = params.get("code");
    if(code && isMounted) {
      setCompanyCamCode(code);
    }

    const timezoneOffset = (new Date()).getTimezoneOffset();
    if(timezoneOffset) {
      const u = getUser();
      if(u && u.tzOffset && u.tzOffset !== timezoneOffset) {
        patchUserTZ(u.userId,timezoneOffset);
        console.log("Updating User TZ",timezoneOffset);
      }
    }

    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    let isMounted = true;
    async function loadCaps() {
      if(getToken()!=null) {
        const tempCaps = await getCaps();
        if(isMounted) {
          setCaps(tempCaps);
          // Preload first 4 ACTIVE caps
          // const activeCaps = tempCaps.filter(cap => cap.status === "ACTIVE").slice(0, 4);
          // for (const cap of activeCaps) {
          //   loadCapPreview(cap.capid);
          // }
        }
        let tempNeighborhoods = {};
        // const tempNeighborhoods = await loadNeighborhoods();
        let nc = getNeighborhoodCollapsed();
        if(nc==null) nc = {};
        for(var i=0; i<tempCaps.length; i++) {
          if(!(tempCaps[i].neighborhoodid in nc)) {
            if(tempCaps.length<=8) { // Leave collaspibles open if they have less than 9 caps
              nc[tempCaps[i].neighborhoodid] = true;
            } else {
              nc[tempCaps[i].neighborhood] = false;
            }
          }
          if(tempCaps[i].neighborhoodid == null) {
            if('none' in tempNeighborhoods) {
              tempNeighborhoods['none'].push(tempCaps[i]);
            } else {
              tempNeighborhoods['none'] = [tempCaps[i]];
            }
          }
          else if(tempCaps[i].neighborhoodid in tempNeighborhoods) {
            tempNeighborhoods[tempCaps[i].neighborhoodid].push(tempCaps[i]);
          } else {
            tempNeighborhoods[tempCaps[i].neighborhoodid] = [tempCaps[i]];
          }
        }
        // Sort caps without neighborhoods
        if('none' in tempNeighborhoods) {
          tempNeighborhoods['none'].sort((a,b) => (a.name > b.name ) ? 1 : -1);
        }
        // Sort neighborhoods
        if(isMounted) {
          setNeighborhoodCollapsed(nc);
          setNeighborhoods(tempNeighborhoods);
          
          setIsLoading(false);
        }
      }
    }
    loadCaps();
    return () => { isMounted = false; };
  }, [localToken, isLoading]);

  // If you go all the way back to dashboard (or if you relogin) you want the sorting to reset
  useEffect(() => {
    let isMounted = true;
    if(neighborhoods && isMounted) {
      setDefaultCameraDirections({});
      setDefaultDaylightParameter({});
      setDefaultPageNumber({});
      setDefaultSortParameter({});
      // getLatestEventsForNeighborhoods();
    }
    return () => { isMounted = false; };
  },[neighborhoods]);

  useEffect(() => {
    let isMounted = true;
    async function getAccessToken() {
      let at = await companyCamAccessToken(companyCamCode);
      console.log(at);
      setCCAccessToken(at);
      createCCIntegration(getUser().userId,at);
    }
    if(companyCamCode) {
      if(CCAccessToken==null && isMounted) {
        getAccessToken();
      }
    }
    return () => { isMounted = false; };
  },[companyCamCode]);

  function renderCapPanel(cap) {
    return (
      <CapPanel
        key={cap.capid}
        cap={cap}
        isLoading={isLoading}
        onShareClick={(cap) => {
          setShowSharingWindow(true);
          setsharableCap(cap);
        }}
      />
    );
  }

  function renderCapsGrid() {
    let allCaps = [];
    
    // Collect all caps from neighborhoods
    for (const neighborhood in neighborhoods) {
      if (neighborhood === 'none') continue;
      
      const neighborhoodCaps = neighborhoods[neighborhood].filter(cap => {
        if (getUser().role === "ADMIN" && cap.status === "BUILD" && !buildCaps) {
          return false;
        }
        return !["DECOMISSIONED", "DEAD"].includes(cap.status);
      });

      if (neighborhoodCaps.length > 0) {
        allCaps.push(...neighborhoodCaps);
      }
    }

    // Add caps without neighborhoods
    if (neighborhoods['none']) {
      allCaps.push(...neighborhoods['none'].filter(cap => {
        if (getUser().role === "ADMIN" && cap.status === "BUILD" && !buildCaps) {
          return false;
        }
        return !["DECOMISSIONED", "DEAD"].includes(cap.status);
      }));
    }

    // Sort all caps by name
    allCaps.sort((a, b) => a.name.localeCompare(b.name));

    return (
      <div className="caps-grid">
        {allCaps.map(cap => renderCapPanel(cap))}
      </div>
    );
  }

  function renderCaps() {
    return (
      <div className="caps">
        <div className="custom-header">
          <h1>Camera Systems</h1>
        </div>

        {!isLoading && renderCapsGrid()}
        
        {!isLoading && Object.keys(neighborhoods).length === 0 && (
          <div className="no-cameras-message">
            <h4>
              Sign up for a CAP or ask our team how to have a demo CAP shared with you
            </h4>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="Home">
      {getToken()!=null ? renderCaps() : renderLander()}
      {caps && (
        <SharingModal 
          cap={sharableCap}
          show={showSharingWindow}
          setErrorStatus={props.setErrorStatus}
          setErrorMessage={props.setErrorMessage}
          setShowError={props.setShowError}
          setShowSharingWindow={setShowSharingWindow}
        />
      )}
      {props && props.showError !== null && getUser() && ( // && getUser().role==='ADMIN' // TODO 
        <Nudge 
          setErrorStatus={props.setErrorStatus} 
          setErrorMessage={props.setErrorMessage}
          setShowError={props.setShowError}
          showError={props.showError}
          history={props.history}
        />
      )}
    </div>
  )
}
